import React from 'react';
import PropTypes from 'prop-types';

import TableCardComponent from './TableCardComponent';

const TableCardContainer = ({
  children,
  category,
  subcategory,
  expanded,
  onViewAll,
}) => {
  const titleMessage = {
    id: 'tableCardTitle',
    defaultMessage: category,
  };
  const subtitleMessage = {
    id: 'tableCardSubtitle',
    defaultMessage: subcategory,
  };

  return (
    <TableCardComponent
      {...{
        title: titleMessage,
        subtitle: subtitleMessage,
        expanded,
        onViewAll,
      }}
    >
      {children}
    </TableCardComponent>
  );
};

TableCardContainer.propTypes = {
  children: PropTypes.node,
  category: PropTypes.string,
  subcategory: PropTypes.string,
  expanded: PropTypes.bool,
  onViewAll: PropTypes.func,
};

export default TableCardContainer;
